import BillingModel from "../../../../../types/billing-model";

export type BillingsOrderRailyTaxiDraftContractTaxiCompany = {
  companyName: string;
};

export type BillingsOrderRailyTaxiDraftContract = {
  model: BillingModel;
  distanceRate: number;
  haltingTimeRate: number;
  haltingTimeAfterMinutes: number;
  taxiCorporation: BillingsOrderRailyTaxiDraftContractTaxiCompany;
};

export type BillingsOrderRailyTaxiDraftBillingNode = {
  uuid: string;
  nodeUuid: string;
  lat: number;
  lon: number;
  description: string;
  checkoutDate?: Date;
  checkoutEventUuid?: string;
  plannedDate?: Date;
  orderUuid?: string;
  distance: number;
  plannedDistance: number;
  haltingTime: number;
  highwayCharge: number;
  allowCharge: boolean;
  editableCoordinates: boolean;
};

export type BillingsOrderRailyTaxiDraftCargoOrder = {
  humanId: number;
};

export enum BillingsOrderRailyTaxiDraftPenaltyType {
  OPTIMIZATION_REFUSED = "OPTIMIZATION_REFUSED",
  BEING_LATE = "BEING_LATE",
  INCOMPATIBLE_CAR = "INCOMPATIBLE_CAR",
  HIGHWAY_NOT_ALLOWED = "HIGHWAY_NOT_ALLOWED",
  SUBOPTIMAL_RIDE = "SUBOPTIMAL_RIDE",
  GUIDELINE_IGNORED = "GUIDELINE_IGNORED",
  OTHER = "OTHER",
}

export enum BillingsOrderRailyTaxiDraftBonusType {
  DISTANCE_RATE_CHANGED = "DISTANCE_RATE_CHANGED",
  HALTING_RATE_CHANGED = "HALTING_RATE_CHANGED",
  SHORT_ROUTE = "SHORT_ROUTE",
  OTHER = "OTHER",
}

type BillingsOrderRailyTaxiDraft = {
  contract: BillingsOrderRailyTaxiDraftContract;
  billingNodes: BillingsOrderRailyTaxiDraftBillingNode[];
  totalAmount: number;
  haltingAmount: number;
  highwayCharge: number;
  distance: number;
  distanceAmount: number;
  cargoOrder: BillingsOrderRailyTaxiDraftCargoOrder;
  planEntryUuid: string;
  bonus: number;
  penalty: number;
  penaltyType?: BillingsOrderRailyTaxiDraftPenaltyType;
  bonusType?: BillingsOrderRailyTaxiDraftBonusType;
  date: Date;
};

export default BillingsOrderRailyTaxiDraft;
